export default "<db:successcriteriareport>\n\t<span data-id='name'></span>\n\t<span data-id='successRate'></span>\n</db:successcriteriareport>\n";